import { render, staticRenderFns } from "./IncidenceOrderInView.vue?vue&type=template&id=4165be7a"
import script from "./IncidenceOrderInView.vue?vue&type=script&lang=js"
export * from "./IncidenceOrderInView.vue?vue&type=script&lang=js"
import style0 from "./IncidenceOrderInView.vue?vue&type=style&index=0&id=4165be7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports